var _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgInfections = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0406\\u043D\\u0444\\u0435\\u043A\\u0446\\u0456\\u0457",
    width: 62.008,
    height: 65,
    viewBox: "0 0 62.008 65",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201",
    transform: "translate(0.081 10.658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    className: "cls-1",
    d: "M29.351,105.7h-10a1.953,1.953,0,0,1-1.686-.974l-5-8.656a1.953,1.953,0,0,1,0-1.948l5-8.656a1.953,1.953,0,0,1,1.687-.974h10a1.953,1.953,0,0,1,1.686.974l5,8.656a1.953,1.953,0,0,1,0,1.947l-5,8.656a1.954,1.954,0,0,1-1.687.974Zm-10-19.271-5.008,8.662,5,8.668,10.005.006L34.359,95.1l-5-8.668-.01-.006Z",
    transform: "translate(-12.412 -84.491)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202",
    transform: "translate(38.124 10.659)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    className: "cls-1",
    d: "M331.5,105.7h-10a1.953,1.953,0,0,1-1.687-.974l-5-8.656a1.953,1.953,0,0,1,0-1.947l5-8.656a1.953,1.953,0,0,1,1.687-.974h10a1.953,1.953,0,0,1,1.687.974l5,8.656a1.953,1.953,0,0,1,0,1.947l-5,8.656A1.953,1.953,0,0,1,331.5,105.7Zm-9.995-19.271L316.5,95.09l5,8.668,10.005.006,5.008-8.662-5-8.668-.01-.006Z",
    transform: "translate(-314.564 -84.492)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203",
    transform: "translate(19.112 21.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    className: "cls-1",
    d: "M180.512,193.57h-10a1.953,1.953,0,0,1-1.686-.974l-5-8.656a1.953,1.953,0,0,1,0-1.947l5-8.656a1.953,1.953,0,0,1,1.687-.974h10a1.953,1.953,0,0,1,1.686.974l.987,1.71a.968.968,0,0,1-1.676.968l-.987-1.71-10.005-.006-5.008,8.662,5,8.668,10.005.006,5.008-8.662-1.761-3.063a.968.968,0,0,1,1.677-.968l1.761,3.051a1.953,1.953,0,0,1,0,1.948l-5,8.656A1.953,1.953,0,0,1,180.512,193.57Z",
    transform: "translate(-163.573 -172.363)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204",
    transform: "translate(19.112 43.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    className: "cls-1",
    d: "M180.512,368.362h-10a1.953,1.953,0,0,1-1.686-.974l-5-8.656a1.953,1.953,0,0,1,0-1.947l5-8.656a1.953,1.953,0,0,1,1.687-.974h10a1.953,1.953,0,0,1,1.686.974l5,8.656a1.953,1.953,0,0,1,0,1.948l-5,8.656A1.953,1.953,0,0,1,180.512,368.362Zm-10-19.271-5.008,8.662,5,8.668,10.005.006,5.008-8.662-5-8.668-.01-.006Z",
    transform: "translate(-163.573 -347.155)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205",
    transform: "translate(19.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    className: "cls-1",
    d: "M180.512,21.207h-10a1.953,1.953,0,0,1-1.686-.974l-5-8.656a1.953,1.953,0,0,1,0-1.947l5-8.656A1.953,1.953,0,0,1,170.517,0h10A1.953,1.953,0,0,1,182.2.974l5,8.656a1.953,1.953,0,0,1,0,1.948l-5,8.656a1.953,1.953,0,0,1-1.687.974Zm-10-19.271L165.509,10.6l5,8.668,10.005.006,5.008-8.662-5-8.668-.01-.006h-10Z",
    transform: "translate(-163.573 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206",
    transform: "translate(0 32.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    className: "cls-1",
    d: "M28.723,279.313h-10a1.953,1.953,0,0,1-1.687-.974l-.822-1.423a.968.968,0,1,1,1.676-.968l.822,1.423,10.005.006,5.008-8.662-5-8.668-10.005-.006L13.721,268.7l1.936,3.364a.968.968,0,1,1-1.676.968l-1.936-3.353a1.953,1.953,0,0,1,0-1.948l5-8.656a1.953,1.953,0,0,1,1.687-.974h10a1.952,1.952,0,0,1,1.686.974l5,8.656a1.953,1.953,0,0,1,0,1.947l-5,8.656a1.953,1.953,0,0,1-1.686.974Z",
    transform: "translate(-11.784 -258.106)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208",
    transform: "translate(6.172 41.189)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    className: "cls-1",
    cx: 1.033,
    cy: 1.033,
    r: 1.033
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(9.196 37.513)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    className: "cls-1",
    cx: 1.033,
    cy: 1.033,
    r: 1.033,
    transform: "translate(0)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210",
    transform: "translate(51.845 15.65)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    className: "cls-1",
    cx: 1.033,
    cy: 1.033,
    r: 1.033
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211",
    transform: "translate(34.327 32.688)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    className: "cls-1",
    cx: 1.033,
    cy: 1.033,
    r: 1.033
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212",
    transform: "translate(33.648 28.648)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    className: "cls-1",
    cx: 1.033,
    cy: 1.033,
    r: 1.033
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInfections, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/infections.67ff4049.svg";
export { ForwardRef as ReactComponent };